"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeBridgeCacheSystem = void 0;
const cache_1 = require("@ledgerhq/live-network/cache");
const _1 = require("./");
const defaultCacheStrategy = {
    preloadMaxAge: 5 * 60 * 1000,
};
function makeBridgeCacheSystem({ saveData, getData, }) {
    const hydrateCurrency = (currency) => __awaiter(this, void 0, void 0, function* () {
        const value = yield getData(currency);
        const bridge = (0, _1.getCurrencyBridge)(currency);
        bridge.hydrate(value, currency);
        return value;
    });
    const lruCaches = {};
    const prepareCurrency = (currency) => __awaiter(this, void 0, void 0, function* () {
        const bridge = (0, _1.getCurrencyBridge)(currency);
        const { preloadMaxAge } = Object.assign(Object.assign({}, defaultCacheStrategy), (bridge.getPreloadStrategy && bridge.getPreloadStrategy(currency)));
        let cache = lruCaches[currency.id];
        if (!cache) {
            cache = (0, cache_1.makeLRUCache)(() => __awaiter(this, void 0, void 0, function* () {
                const preloaded = yield bridge.preload(currency);
                if (preloaded) {
                    bridge.hydrate(preloaded, currency);
                    yield saveData(currency, preloaded);
                }
                return preloaded;
            }), () => "", {
                ttl: preloadMaxAge,
            });
            lruCaches[currency.id] = cache;
        }
        return cache();
    });
    return {
        hydrateCurrency,
        prepareCurrency,
    };
}
exports.makeBridgeCacheSystem = makeBridgeCacheSystem;
//# sourceMappingURL=cache.js.map